import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { FilterState } from '../../generic/classes/filter.state';
import { Product } from '../../generic/classes/product';
import { ProductDetail } from '../../generic/classes/product.detail';
import { Logger } from '../../generic/logging/default-log.service';
import { FilterService } from '../../generic/service/filter.service';
import { ProductService } from '../../generic/service/product.service';
import { UserService } from '../../generic/service/user.service';
import { LazyLoadDirective } from '../../generic/component/lazyload/ng-lazy-load.directive';
import { ProductItemGridComponent } from '../../generic/component/products/productitem.grid.component';

/**
 * Used to show alternative products when the current product is type history and not available
 *
 * @author evandongen
 */
@Component({
    templateUrl: './not.available.alternative.products.component.html',
    selector: 'not-available-alternative-products',
    standalone: true,
    imports: [ProductItemGridComponent, LazyLoadDirective],
})
export class NotAvailableAlternativeProductsComponent implements OnInit {
    productService = inject(ProductService);
    filterService = inject(FilterService);
    router = inject(Router);
    logger = inject(Logger);

    @Input() product: Product | ProductDetail;

    public products: Product[];
    public readonly _userService: UserService;

    constructor() {
        const userService = inject(UserService);

        this._userService = userService;
    }

    get userService(): UserService {
        return this._userService;
    }

    ngOnInit() {
        this.getAlternatives(this.filterService.getFilterState());
    }

    public viewProductDetail(detailUrl) {
        this.router.navigateByUrl(detailUrl);
    }

    private getAlternatives(filterState: FilterState) {
        this.productService
            .getAlternativeProducts(
                filterState,
                this.product.type,
                this.product.priceListNo,
                this.product.priceListLineNo,
            )
            .then(products => {
                this.products = products;
            })
            .catch(error => {
                this.logger.error(
                    'Error loading alternative products from the server',
                    error,
                );
            });
    }
}
